const BaseComponent = require('common/home/view');
const Server = require('helper/server');

// const listTpl = Handlebars.templates['common/home/templates/activity-list-item'];

class Home extends BaseComponent {
  constructor () {
    super();
    this.init();
  }

  init () {
    Server.getRedBlackHomeList({
      pageNo: 1,
      pageSize: 6,
      userType: 1, // 供应商
      type: 1 // 红榜
    }).then((data) => {
      if (data && data.itemList && data.itemList.length > 0) {
        const itemList = data.itemList || [];
        itemList.forEach((item, index) => {
          $('#red-rankint').append(`<div class="rankint-item"><div><span class="order red">${index + 1}</span></div><div class="no-wrap" title="${item.name}"><a ${item.url ? `href="${item.url}" target="_blank"` : ''}>${item.name}</a></div></div>`);
        });
      } else {
        $('#red-rankint').append('<p class="noData">暂无数据</p>');
      }
    });
    Server.getRedBlackHomeList({
      pageNo: 1,
      pageSize: 6,
      userType: 1, // 供应商
      type: 2 // 黑榜
    }).then((data) => {
      if (data && data.itemList && data.itemList.length > 0) {
        const itemList = data.itemList || [];
        itemList.forEach((item, index) => {
          $('#black-rankint').append(`<div class="rankint-item"><div><span class="order black">${index + 1}</span></div><div class="no-wrap" title="${item.name}"><a ${item.url ? `href="${item.url}" target="_blank"` : ''}>${item.name}</a></div></div>`);
        });
      } else {
        $('#black-rankint').append('<p class="noData">暂无数据</p>');
      }
    });
  }
}

module.exports = Home;
